import React from 'react';
import DATA_HOOKS from '../DataHooks';
import { st, classes } from './Hash.st.css.js';
export const Hash = ({ disabled, size }) => (React.createElement("div", { "data-hook": DATA_HOOKS.COLOR_INPUT_HASH, "data-disabled": disabled, className: st(classes.root, { disabled, size }) }, "#"));
//# sourceMappingURL=Hash.js.map